import { namespace } from 'vuex-class';
import { IDocumentsState } from './documents.types';

export const DocumentsNamespace = namespace('documents');

export function getDefaultState(): IDocumentsState {
  return {
    isLoadingTags: false,
    documents: [],
    isLoadingDocuments: true,
    error: false,
  };
}

export enum EDocumentsAction {
  LoadDocumentList = 'loadDocumentList',
  LoadDocumentListSuccess = 'loadDocumentListSuccess',
  LoadDocumentListFailed = 'loadDocumentListFailed',
  LoadMoreDocuments = 'loadMoreDocuments',
}

export enum EDocumentsMutation {
  SetDocuments = 'setDocuments',
  SetIsLoadingDocuments = 'setIsLoadingDocuments',
  SetError = 'setError',
}
